@import "../../scss/mixins";
@import url("~mapbox-gl/dist/mapbox-gl.css");
@import url("~@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css");

#map,
.container {
  height: 100%;
  width: 100%;
}

.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
  display: none;
}

// compass control
.mapboxgl-ctrl-top-right {
  background-color: transparent;
  margin-top: 10px !important;

  .mapboxgl-ctrl-group {
    background-color: transparent;
    margin-top: 0 !important;

    button {
      border: none;
    }
  }

  .mapboxgl-ctrl-compass,
  .mapboxgl-ctrl-zoom-in,
  .mapboxgl-ctrl-zoom-out,
  .mapboxgl-ctrl-toggle,
  .mapboxgl-ctrl-fullscreen {
    width: 40px;
    height: 40px;
    border-radius: 2px !important;
    background-color: var(--color-dark-bg) !important;
    margin-bottom: 5px !important;

    &:hover {
      background-color: var(--color-primary-accent) !important;
    }
  }

  .mapboxgl-ctrl-icon-modified {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  // search control
  .mapboxgl-ctrl-geocoder {
    background: var(--color-dark-bg);
    transition: none;
    border-radius: 2px;
    height: 40px;
    width: 40px;
    margin-top: 0 !important;
    margin-bottom: 5px !important;
    position: absolute;
    right: 47px;

    &--collapsed {
      width: 40px;
      height: 40px;
      background-repeat: no-repeat !important;
      background-position: calc(12px) center !important;

      input {
        display: none;
      }

      svg {
        display: none;
      }
    }

    &--button {
      background-color: var(--color-dark-bg);
    }

    &--icon-search {
      fill: var(--color-basic-text);
      left: 10px;
    }

    .mapboxgl-ctrl-geocoder--pin-right > button {
      opacity: 1;
      background: none;
    }

    input {
      background-color: var(--color-dark-bg) !important;
      color: var(--color-basic-text) !important;

      &:focus {
        outline: dotted var(--color-primary-accent) 0.5px;
      }
    }

    div.suggestions-wrapper {
      .suggestions {
        background-color: var(--color-dark-bg) !important;
        color: var(--color-basic-text) !important;

        .mapboxgl-ctrl-geocoder--suggestion {
          color: var(--color-basic-text) !important;
        }

        a:hover {
          background-color: #f6678db5;
        }

        .active > a {
          background-color: #f6678c;
        }
      }
    }
  }

  .mapboxgl-ctrl-zoom-in {
    margin-bottom: 0 !important;
  }
}

.mapboxgl-ctrl-fullscreen.active {
  background-color: var(--color-primary-accent) !important;
}

// hide mapbox logo
#map
  > div.mapboxgl-control-container
  > div.mapboxgl-ctrl-bottom-left
  > div
  > a {
  display: none;
}

.mapboxgl-ctrl-legend {
  background-color: transparent;

  ul {
    display: none;
    margin-bottom: 10px !important;
    padding: 12px;
    background: #0c1027;
    border: 1px solid #96a5ef;
    box-shadow: 0 0 16px #0c102780;
    border-radius: 2px;
    margin: 0;

    li {
      color: #e3e3e5;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      line-height: 20px;
      font-family: "Rubik", sans-serif;
      font-weight: 400;

      img {
        margin-right: 8px;
      }
    }
  }
  button {
    width: 40px;
    height: 40px;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 2px !important;
    background-color: var(--color-dark-bg) !important;
    margin-bottom: 5px !important;
    margin: 0 !important;
    padding: 0 !important;

    &:hover {
      background-color: var(--color-primary-accent) !important;
    }
  }
}
